<template>
  <div class="task-tags-select">
    <div
      class="task-tags-select__tag"
      v-for="option in selectedOptions"
      :key="option.Id"
      :style="{ borderColor: option.Color }"
    >
      <span class="task-tags-select__tag-name" :style="{ color: option.Color }">{{
        option.Name
      }}</span>
      <span v-if="editing" class="task-tags-select__tag-separator" />
      <button
        v-if="editing"
        class="task-tags-select__tag-button"
        @click.stop="unSelectOption(option.Id)"
      >
        <svg
          class="task-tags-select__tag-button-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033L10.9393 12L8.46967 14.4697C8.17678 14.7626 8.17678 15.2374 8.46967 15.5303C8.76256 15.8232 9.23744 15.8232 9.53033 15.5303L12 13.0607L14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L13.0607 12L15.5303 9.53033C15.8232 9.23744 15.8232 8.76256 15.5303 8.46967C15.2374 8.17678 14.7626 8.17678 14.4697 8.46967L12 10.9393L9.53033 8.46967Z"
          />
        </svg>
      </button>
      <div class="task-tags-select__tag-bg" :style="{ backgroundColor: option.Color }" />
    </div>
    <div v-if="editing" class="task-tags-select__button">
      <TirPmMultiselect
        popoverClasses="task-tags-select__multiselect"
        ref="$multiselect"
        searchInputLabel="Поиск тегов"
        :options="multiselectOptions"
        :selected-options="selectedOptions"
        :popover-position="popoverPosition"
        popover-width="32.5rem"
        :is-disabled-popover="!multiselectOptions.length && isRegularUser"
        @onOpen="checkOpenMultiselect"
      >
        <template #target>
          <div>
            <TirPmButton
              v-if="!modelValue.length"
              :variant="TirPmButtonVariantEnum.SecondaryState"
              :isDisabled="!multiselectOptions.length && isRegularUser"
              :size="TirPmButtonSizeEnum.Small"
              :isPressed="isOpenMultiselect"
            >
              <template #leftSlot>
                <PlusIcon />
              </template>
              Добавить тег
            </TirPmButton>
            <TirPmButton
              v-else
              :variant="TirPmButtonVariantEnum.LinkState"
              :size="TirPmButtonSizeEnum.Small"
              :isPressed="isOpenMultiselect"
            >
              <template #leftSlot>
                <PlusIcon style="color: var(--text-primary, #272d37)" />
              </template>
            </TirPmButton>
          </div>
        </template>
        <template #selectedContent>
          <div class="task-tags-select__selected-content">
            <div
              class="task-tags-select__tag"
              v-for="option in selectedOptions"
              :key="option.Id"
              :style="{ borderColor: option.Color }"
            >
              <span class="task-tags-select__tag-name" :style="{ color: option.Color }">{{
                option.Name
              }}</span>
              <span class="task-tags-select__tag-separator" />
              <button class="task-tags-select__tag-button" @click="unSelectOption(option.Id)">
                <svg
                  class="task-tags-select__tag-button-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033L10.9393 12L8.46967 14.4697C8.17678 14.7626 8.17678 15.2374 8.46967 15.5303C8.76256 15.8232 9.23744 15.8232 9.53033 15.5303L12 13.0607L14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L13.0607 12L15.5303 9.53033C15.8232 9.23744 15.8232 8.76256 15.5303 8.46967C15.2374 8.17678 14.7626 8.17678 14.4697 8.46967L12 10.9393L9.53033 8.46967Z"
                  />
                </svg>
              </button>
              <div class="task-tags-select__tag-bg" :style="{ backgroundColor: option.Color }" />
            </div>
          </div>
          <div v-if="!multiselectOptions.length" class="task-tags-select__missing-tags">
            <TirPmIconView :is-bordered="false" :size="48" class="task-tags-select__tag-icon-block">
              <template #mainSlot>
                <TagIcon class="task-tags-select__tag-icon" />
              </template>
            </TirPmIconView>
            <div class="task-tags-select__missing-tags-text">
              В проекте нет тегов для добавления
            </div>

            <TirPmButton
              :variant="TirPmButtonVariantEnum.PrimaryState"
              :size="TirPmButtonSizeEnum.Small"
              @click="redirectToTags"
            >
              Перейти к созданию тегов
            </TirPmButton>
          </div>
        </template>
        <template #rightInputAddons>
          <TirPmTooltipElement
            width="max-content"
            v-if="isOwner || isNamespaceAdmin || isProjectAdmin"
          >
            <TirPmButton
              class="task-tags-select__button-plus"
              :variant="TirPmButtonVariantEnum.SecondaryState"
              :size="TirPmButtonSizeEnum.Regular"
              @click="redirectToTags"
            >
              <PlusIcon class="task-tags-select__plus-icon" />
            </TirPmButton>
            <template #content>
              <div class="task-tags-select__button-plus-hint">Перейти к созданию тегов</div>
            </template>
          </TirPmTooltipElement>
        </template>
        <template #optionList="{ option }">
          <div class="task-tags-select__option" @click="selectOption(option.Id)">
            <div class="task-tags-select__tag" :style="{ borderColor: option.Color }">
              <span class="task-tags-select__tag-name" :style="{ color: option.Color }">{{
                option.Name
              }}</span>
              <div class="task-tags-select__tag-bg" :style="{ backgroundColor: option.Color }" />
            </div>
            <TirPmTooltipElement v-if="option.Description" width="15rem">
              <template #content>
                <div class="task-tags-select__option__description">
                  {{ option.Description }}
                </div>
              </template>
              <template #default>
                <InformationCircleIcon class="task-tags-select__option__icon" />
              </template>
            </TirPmTooltipElement>
          </div>
        </template>
      </TirPmMultiselect>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, PropType, ref } from "vue";
import { TagModel } from "../../models";
import { TagMultiselectOptionModel } from "./models";
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  PopoverPositionEnum,
  PopoverPositionType,
  TirPmIconView,
  TirPmPopover,
  PopoverColorEnum,
  TirPmMultiselect,
  TirPmTooltipElement,
} from "tir-components";
import { PlusIcon, TagIcon, InformationCircleIcon } from "tir-style-system/icons/outline";
import { CurrentUser, UserRoleEnum } from "tir-pm-user-core";
import { useRouter } from "vue-router";

const emit = defineEmits<{
  /**Событие обновления выбранных тегов */
  (e: "update:modelValue", value: Array<number>): void;
}>();

const props = defineProps({
  /**Возможность редактировать */
  editing: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**Выбранные теги */
  modelValue: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Список тегов для выбора */
  options: {
    type: Array as PropType<Array<TagModel>>,
    default: [],
  },
  /**Является ли юзер админом НС */
  isNamespaceAdmin: {
    type: Boolean,
  },
  /**Является ли юзер админом проекта */
  isProjectAdmin: {
    type: Boolean,
  },
});

const router = useRouter();

/**Ссылка на компонент Multiselect */
const $multiselect = ref<{ updatePopover: () => void } | undefined>(); // InstanceType не работает с дженерик компонентами

/**Опции мультиселекта */
const multiselectOptions = computed(() =>
  props.options.map(
    (option) =>
      new TagMultiselectOptionModel({
        Id: option.Id,
        Name: option.Name,
        Color: option.Color,
        Description: option.Description,
      }),
  ),
);

/**Овнер */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);

const isOpenMultiselect = ref();

/**Является ли текующий пользователь обычным юзером  */
const isRegularUser = CurrentUser.Roles.includes(1);

const checkOpenMultiselect = () => {
  isOpenMultiselect.value = !isOpenMultiselect.value;

  // event.stopPropagation();
  document.addEventListener("click", () => {
    isOpenMultiselect.value = false;
  });
};

/**Выбранные опции */
const selectedOptions = computed(() =>
  multiselectOptions.value.filter((option) => props.modelValue.includes(option.Id)),
);

const popoverPosition = computed<any>(() => {
  if (!props.modelValue.length)
    return {
      top: "0.25rem + $el:height",
      left: "0rem",
    };
  return PopoverPositionEnum.Bottom;
});

/**Выбор опции */
const selectOption = async (optionId: number) => {
  emit("update:modelValue", [...props.modelValue, optionId]);
  await nextTick();
  $multiselect.value?.updatePopover();
};

/**Перенапровление на страницу создания тегов */
const redirectToTags = () => {
  const route = router.resolve({
    name: "project-tags",
  });
  window.open(route.href, "_blank");
};

/**Убрать выбор опции */
const unSelectOption = async (optionId: number) => {
  emit(
    "update:modelValue",
    props.modelValue.filter((_optionId) => optionId !== _optionId),
  );
  await nextTick();
  $multiselect.value?.updatePopover();
};
</script>

<style lang="scss">
.task-tags-select {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 0.25rem;
  row-gap: 0.375rem;

  &__button-plus-hint {
    padding: 0.75rem;
  }

  &__button-plus {
    width: 3rem !important;
    min-width: 3rem !important;
    height: 3rem !important;
    border-radius: 0.75rem !important;
  }
  &__missing-tags {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0.5rem 0.75rem;
  }

  &__missing-tags-text {
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: 1rem;
  }

  &__tag-icon-block {
    margin-bottom: 0.75rem;
  }

  &__plus-icon {
    width: 1.5rem;
    height: 1.5rem;
  }

  &__tag-icon {
    width: 2.25rem !important;
    min-width: 2.25rem !important;
    height: 2.25rem !important;
  }

  &__option {
    padding: 0.5rem 0.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__icon {
      width: 1.5rem;
      height: 1.5rem;
    }
    &__description {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 2.25rem;
      padding: 0 0.5rem;
      word-break: break-word;
    }
  }
  &__tag {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.125rem 0.5rem;
    border-radius: 0.25rem;
    border-style: solid;
    border-width: 0.063rem;
    overflow: hidden;
    z-index: 1;
  }

  &__tag-name {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
  }
  &__tag-separator {
    align-self: stretch;
    flex-shrink: 0;
    width: 0.063rem;
    background-color: var(--text-tertiary, #93969b);
    margin: 0.125rem 0;
  }
  &__tag-button {
    width: 1rem;
    height: 1rem;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  &__tag-button-icon {
    width: 1rem;
    height: 1rem;
    path {
      fill: var(--text-tertiary, #93969b);
    }
  }

  &__tag-bg {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    opacity: 0.1;
    z-index: -1;
  }
  &__selected-content {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    width: 25rem;
  }
}
</style>

<style lang="scss">
.task-tags-select__multiselect .tir-pm-multiselect__popover-content {
  padding-bottom: 0 !important;
}
.task-tags-select__multiselect
  .tir-pm-multiselect__popover-content
  .tir-pm-multiselect__option-list
  .tir-pm-multiselect__option-list-inner
  > div:first-child
  .task-tags-select__option {
  padding: 1rem 0.75rem 0.5rem 0.75rem;
}
.task-tags-select__multiselect
  .tir-pm-multiselect__popover-content
  .tir-pm-multiselect__option-list
  .tir-pm-multiselect__option-list-inner
  > div:last-child
  .task-tags-select__option {
  padding: 0.5rem 0.75rem 1rem 0.75rem;
}

.task-tags-select__button-plus .button__sign .button__sign-main {
  display: flex;
}
</style>
